module.exports = __webpack_public_path__ + "img/3.27a2b1b7.png";